import { NgModule } from '@angular/core';
import { CheckoutComponentsModule } from '@spartacus/checkout/base/components';
import { CheckoutRootModule, CHECKOUT_FEATURE } from '@spartacus/checkout/base/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [CheckoutRootModule, CheckoutComponentsModule],
  providers: [
    provideConfig({
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('@spartacus/checkout/base').then((m) => m.CheckoutModule),
        },
      },
    }),
  ],
})
export class CheckoutFeatureModule {}
